import { c as _c } from "react/compiler-runtime";
import { PartnerHospitalTagCode } from "@/entities/hospital/api/types";
import { Icon, Typography } from "@/shared/ui/atoms";
import { getPartnerHospitalTagLabel } from "@/widgets/hospital/lib/partnerHospitalTags";
interface HospitalTagProps {
  tag: PartnerHospitalTagCode;
}
const HospitalTag = t0 => {
  const $ = _c(14);
  const {
    tag
  } = t0;
  let t1;
  if ($[0] !== tag) {
    t1 = getPartnerHospitalTagLabel(tag);
    $[0] = tag;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tagLabel = t1;
  let t2;
  if ($[2] !== tag) {
    t2 = tag.toLowerCase();
    $[2] = tag;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/icons/${t2}.png`;
  let t4;
  if ($[4] !== t3) {
    t4 = t3.replace("_", "-");
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const tagIcon = t4;
  let t5;
  if ($[6] !== tag || $[7] !== tagIcon) {
    t5 = <Icon src={tagIcon} alt={tag} width={16} height={16} />;
    $[6] = tag;
    $[7] = tagIcon;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== tagLabel) {
    t6 = <Typography size={12} lineHeight={16} className="text-gray-700 font-medium">{tagLabel}</Typography>;
    $[9] = tagLabel;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="w-fit py-[3px] px-[5px] flex items-center gap-[3px] font-medium rounded whitespace-nowrap border border-gray-100">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default HospitalTag;